/** @jsx jsx */
import { jsx } from '@emotion/react';

import EnterpriseLearningPathsModule from 'bundles/page-config-common/components/enterprise/EnterpriseLearningPathsModule';
import EnterpriseSingleLearningPathModule from 'bundles/page-config-common/components/enterprise/EnterpriseSingleLearningPathModule';
import { useEnterpriseBadgeCollections } from 'bundles/page-config-common/contexts/enterprise/EnterpriseBadgeCollectionsContext';

const EnterpriseLearningPathsNotConfigurable = () => {
  const { enterpriseBadgesWithCollection } = useEnterpriseBadgeCollections();

  if (enterpriseBadgesWithCollection.length === 0) {
    return null;
  }
  if (enterpriseBadgesWithCollection.length === 1) {
    return <EnterpriseSingleLearningPathModule enterpriseBadgeWithCollection={enterpriseBadgesWithCollection[0]} />;
  }
  return <EnterpriseLearningPathsModule enterpriseBadgesWithCollection={enterpriseBadgesWithCollection} />;
};

export default EnterpriseLearningPathsNotConfigurable;
